const DEFAULT_API_BASE_URL = "http://localhost:5000";
const DEFAULT_COOKIE_APPLICATION_ID = "00580ff6-3251-428c-bd99-5b2cb5b67caa";
const DEFAULT_COOKIE_POLICY_VERSION = "1.0";

export const API_CONFIG = {
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? DEFAULT_API_BASE_URL,
  graphqlBaseUrl: "",
  cookieApplicationId:
    import.meta.env.VITE_COOKIE_APPLICATION_ID ?? DEFAULT_COOKIE_APPLICATION_ID,
  cookiePolicyVersion:
    import.meta.env.VITE_COOKIE_POLICY_VERSION ?? DEFAULT_COOKIE_POLICY_VERSION,
};

export function setApiBaseUrl(url: string): void {
  API_CONFIG.baseUrl = url;
}

export function setGraphqlBaseUrl(url: string): void {
  API_CONFIG.graphqlBaseUrl = url;
}
